var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened === true
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c(
                "div",
                {
                  staticClass: "modal-content",
                  staticStyle: { height: "calc(100vh - 50px)" },
                },
                [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Combined panels"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _vm.initialized === false
                      ? _c("h2", [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                          _vm._v(" Loading..."),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.initialized
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "alert alert-info",
                              attrs: { role: "alert" },
                            },
                            [
                              _vm._v(
                                "\n                            You can include another panel as if it were a respondent.\n                            This lets you, for example, combine and compare votes from different groups of people.\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("table", { staticClass: "table table-hover" }, [
                              _c(
                                "tbody",
                                _vm._l(_vm.entries, function (s) {
                                  return _c("tr", { key: s.Id }, [
                                    _c("td", [_vm._v(_vm._s(s.Name))]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "20%" } },
                                      [
                                        _c("div", { staticClass: "dropdown" }, [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "text-primary",
                                              attrs: {
                                                "data-toggle": "dropdown",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(
                                                    s.IsIncluded
                                                      ? `Vote strength ${s.VoteStrength}`
                                                      : "Not included"
                                                  ) +
                                                  "\n                                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "dropdown-menu",
                                              attrs: { role: "menu" },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.emitExcludeSubSurvey(
                                                        s.Id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Not included")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(11, function (num) {
                                                return _c(
                                                  "a",
                                                  {
                                                    key: num,
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.emitIncludeSubSurvey(
                                                          s.Id,
                                                          num - 1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                        Vote strength: " +
                                                        _vm._s(num - 1) +
                                                        "\n                                                    "
                                                    ),
                                                  ]
                                                )
                                              }),
                                            ],
                                            2
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "20%" } },
                                      [
                                        s.IsIncluded
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "progress",
                                                staticStyle: { margin: "0" },
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "progress-bar progress-bar-success progress-bar-striped",
                                                  style: {
                                                    width: s.Progress + "%",
                                                  },
                                                  attrs: {
                                                    title: s.Progress,
                                                    role: "progressbar",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ])
                                }),
                                0
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("Close")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }